import { useState, useEffect, useCallback, useContext } from "react";
import { TextField, Grid, InputAdornment } from "@material-ui/core";

import "./benefitSelection.css";
import prefixCharacterAddition from "../../../../../../../../../utils/commonFunctions/prefixCharacterAddition";

const BenefitSelection = (props: any) => {
	const [isPrintable, setIsPrintable] = useState(props.isPrintable);

	return (
		<div className="benefit-selection" id="benefit-selection">
			<div className="benefit-container" id="benefit-container">
				<div className="information-container">
					Mark the box or boxes for each type of Group Insurance you are applying for. All Insurance amounts
					are subject to the limitations and exclusions stated in the policy and certificate.
				</div>
				<div className="basic-group-header">Basic Group Insurance</div>
				<div className="section-header-container">
					<Grid container spacing={1}>
						<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="Employer-header">
							<div className="employer-label">Employer Completes this Section</div>
							<div className="class-header">
								<Grid container spacing={1}>
									<Grid
										item
										xs={isPrintable ? 5 : 6}
										sm={isPrintable ? 5 : 6}
										md={isPrintable ? 5 : 6}
										lg={isPrintable ? 5 : 6}
										xl={isPrintable ? 5 : 6}
										className={isPrintable ? "class-label-print" : "class-label"}
									>
										Class
									</Grid>
									<Grid
										item
										xs={isPrintable ? 7 : 6}
										sm={isPrintable ? 7 : 6}
										md={isPrintable ? 7 : 6}
										lg={isPrintable ? 7 : 6}
										xl={isPrintable ? 7 : 6}
										className={isPrintable ? "effective-date-label-print" : "effective-date-label"}
									>
										Effective Date
									</Grid>
								</Grid>
							</div>
						</Grid>
						<Grid
							item
							xs={3}
							sm={3}
							md={3}
							lg={3}
							xl={3}
							className={isPrintable ? "insurance-header-print" : "insurance-header"}
						>
							Type of Insurance
						</Grid>
						<Grid
							item
							xs={3}
							sm={3}
							md={3}
							lg={3}
							xl={3}
							className={isPrintable ? "amount-insurance-header-print" : "amount-insurance-header"}
						>
							Amount of Insurance
						</Grid>
						<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="premium-header">
							Total Premium
						</Grid>
					</Grid>
				</div>
				<div className="optional-group-header">Voluntary/Optional Group Insurance</div>
				<div className="section-value-container">
					<Grid container spacing={1}>
						<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="Employer-header">
							<Grid container spacing={1}>
								<Grid
									item
									xs={isPrintable ? 5 : 6}
									sm={isPrintable ? 5 : 6}
									md={isPrintable ? 5 : 6}
									lg={isPrintable ? 5 : 6}
									xl={isPrintable ? 5 : 6}
									className={isPrintable ? "class-value-print" : "class-value"}
								>
									<TextField
										className="text-field"
										id="text-field"
										name="class"
										// value={lincolnForm.class}
										// onChange={props.handleEnrollmentChange}
										inputProps={{ readOnly: true }}
										style={{
											width: isPrintable ? "80px" : "100px",
											borderRadius: 50
										}}
									/>
								</Grid>
								<Grid
									item
									xs={isPrintable ? 7 : 6}
									sm={isPrintable ? 7 : 6}
									md={isPrintable ? 7 : 6}
									lg={isPrintable ? 7 : 6}
									xl={isPrintable ? 7 : 6}
									className={isPrintable ? "effective-date-value-print" : "effective-date-value"}
								>
									<span className="textfield-container">
										<TextField
											className="date-field"
											id="text-field"
											placeholder="MM"
											name="month"
											value={
												props?.effectiveDate
													? prefixCharacterAddition(
															new Date(props?.effectiveDate).getMonth() + 1
													  )
													: ""
											}
											style={{
												width: "30px",
												borderRadius: 50
											}}
											inputProps={{ readOnly: true }}
										/>
									</span>
									/
									<span className="textfield-container">
										<TextField
											className="date-field"
											id="text-field"
											placeholder="DD"
											name="day"
											value={
												props?.effectiveDate
													? prefixCharacterAddition(new Date(props?.effectiveDate).getDate())
													: ""
											}
											onChange={props.handleEffectiveDateChange}
											style={{
												marginLeft: "3px",
												width: "30px",
												borderRadius: 50
											}}
											inputProps={{ readOnly: true }}
										/>
									</span>
									/
									<span className="textfield-container">
										<TextField
											className="date-field"
											id="text-field"
											placeholder="YYYY"
											name="year"
											value={
												props?.effectiveDate ? new Date(props?.effectiveDate).getFullYear() : ""
											}
											style={{
												marginLeft: "3px",
												width: "50px",
												borderRadius: 50
											}}
											inputProps={{ readOnly: true }}
										/>
									</span>
								</Grid>
							</Grid>
						</Grid>
						<Grid
							item
							xs={3}
							sm={3}
							md={3}
							lg={3}
							xl={3}
							className={isPrintable ? "insurance-value-print" : "insurance-value"}
						>
							<span className={isPrintable ? "buy-up-text-print" : "buy-up-text"}>
								Buy-Up Long Term Disability (LTD):{" "}
							</span>
							<span className="yes-radio-field">
								<input
									disabled
									type="checkbox"
									id="buy-up-ltd"
									name="buy_up_yes"
									// checked={lincolnForm.buy_up_ltd}
									// onChange={props.handleCheck}
								/>
								  <label htmlFor="yes">Yes</label>
							</span>
							<span className="no-radio-field">
								<input
									disabled
									type="checkbox"
									id="buy-up-ltd"
									name="buy_up_no"
									// checked={lincolnForm.buy_up_ltd === false ? true : false}
									// onChange={props.handleCheck}
								/>
								  <label htmlFor="no">No*</label>
							</span>
						</Grid>
						<Grid item xs={3} sm={3} md={3} lg={3} xl={3} className="amount-insurance-value">
							<span className="monthly-benefit-text">Monthly Benefit Amount: </span>
							<span>
								<TextField
									className="text-field"
									id="text-field"
									name="monthly_benefit_amount"
									// value={lincolnForm.monthly_benefit_amount}
									// onChange={props.handleEnrollmentChange}
									InputProps={{
										startAdornment: <InputAdornment position="start">$</InputAdornment>,
										readOnly: true
									}}
									style={{
										width: "85px",
										borderRadius: 50
									}}
								/>
							</span>
						</Grid>
						<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="premium-value">
							{/* <span className="dollar-symbol">$</span> */}
							<span>
								<TextField
									className="text-field"
									id="text-field"
									name="total_premium"
									value={props?.totalPremium}
									InputProps={{
										startAdornment: <InputAdornment position="start">$</InputAdornment>,
										readOnly: true
									}}
									style={{
										width: "100px",
										borderRadius: 50
									}}
								/>
							</span>
						</Grid>
					</Grid>
				</div>
			</div>
			<div className="note-container" id="note-container">
				*By Selecting No, application for insurance at a later date may require further medical information
				and/or a physical exam, which will be at my own expense.
			</div>
			<div className="deduction-container" id="deduction-container">
				--Actual deductions may vary slightly from above illustrations due to rounding--.
			</div>
		</div>
	);
};

export default BenefitSelection;
